import routeConstant from "common/routeConstants";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, useHistory } from "react-router-dom";

const PublicRoute = ({ component: Component, ...props }) => {
  const history = useHistory();
  const tokenReducer = useSelector((state) => state.tokenReducer);

  useEffect(() => {
    if (tokenReducer && tokenReducer.token) {
      history.push(routeConstant.projectList);
    }
  }, [tokenReducer]); // eslint-disable-line

  return (
    <Route
      {...props}
      render={(innerProps) =>
        tokenReducer && !tokenReducer.token && <Component {...innerProps} />
      }
    />
  );
};
export default PublicRoute;
